import type { QuickscanResult } from '@wtta/scoring'

interface ScorePreviewProps {
  result: QuickscanResult
  onContinue: () => void
}

const RISK_COPY: Record<QuickscanResult['riskLevel'], { headline: string; tone: string }> = {
  low: {
    headline: 'Je staat er goed voor',
    tone: 'Jouw organisatie laat een sterk WTTA-profiel zien op basis van deze quickscan. Er zijn nog kleine optimalisaties mogelijk — die staan in jouw rapport.',
  },
  medium: {
    headline: 'Je bent op de goede weg',
    tone: 'Op een aantal punten heb je jouw zaken goed op orde. Op andere punten is gerichte actie nodig om voor de WTTA-ingangsdatum compliant te zijn.',
  },
  high: {
    headline: 'Er is werk aan de winkel',
    tone: 'Jouw organisatie loopt op meerdere onderdelen risico onder de WTTA. Het rapport laat per onderwerp zien welke stappen prioriteit hebben.',
  },
}

export function ScorePreview({ result, onContinue }: ScorePreviewProps) {
  const copy = RISK_COPY[result.riskLevel]

  return (
    <section className="wtta-step wtta-step--score" data-testid="score-preview">
      <div
        className={`wtta-score wtta-score--${result.riskLevel}`}
        aria-label={`Readiness score: ${result.readinessPercentage} procent`}
      >
        <span className="wtta-score__value">{result.readinessPercentage}%</span>
        <span className="wtta-score__label">readiness</span>
      </div>

      <h2 className="wtta-title">{copy.headline}</h2>
      <p className="wtta-lead">{copy.tone}</p>

      <ul className="wtta-categories">
        {result.categoryScores.map((category) => (
          <li key={category.categoryId} className={`wtta-category wtta-category--${category.riskLevel}`}>
            <span className="wtta-category__title">{category.categoryTitle}</span>
            <span className="wtta-category__score">{category.percentage}%</span>
          </li>
        ))}
      </ul>

      <button
        type="button"
        className="wtta-button wtta-button--primary"
        onClick={onContinue}
        data-testid="continue-to-lead-capture"
      >
        Vraag jouw uitgebreide rapport aan
      </button>
      <p className="wtta-fineprint">
        Je ontvangt het rapport binnen enkele minuten in jouw inbox, met aanbevelingen
        en een 90-dagen planning op maat.
      </p>
    </section>
  )
}
